import React from 'react';
import { X, Loader } from 'lucide-react';

const FilePreview = ({ files, onDelete, uploadingCount }) => {
  const cdnUrl = process.env.REACT_APP_CDN_URL || 'https://files.500kb.com';

  const getThumbnail = (file) => {
    return `${cdnUrl}/${file.thumbnail_url}`;
  };

  // Create array for loaders
  const loaders = Array.from({ length: uploadingCount }, (_, index) => (
    <div key={`loader-${index}`} className="w-[100px] h-[100px] relative rounded bg-neutral-600 flex items-center justify-center">
      <Loader className="animate-spin text-blue-500" size={24} />
    </div>
  ));

  return (
    <div className="flex gap-2 px-4 pt-4 flex-wrap">
      {/* Existing files */}
      {files.map((file) => (
        <div key={file.file_uuid} className="w-[100px] h-[100px] relative rounded bg-neutral-600 group">
          <img
            src={getThumbnail(file)}
            alt="Uploaded file"
            className="w-full h-full object-cover rounded"
          />
          <button
            onClick={() => onDelete(file.file_uuid)}
            className="absolute -top-1.5 -right-1.5 bg-red-500 rounded-full p-1 
                     opacity-0 group-hover:opacity-100 transition-opacity"
          >
            <X size={14} className="text-white" />
          </button>
        </div>
      ))}
      
      {/* Loaders for uploading files */}
      {loaders}
    </div>
  );
};

export default FilePreview;